import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';

import { ALTERNATIVE_PAYOUT_METHODS } from '../../util/alternativePayout';

import css from './IconPayoutMethod.module.css';

const WiseIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
    <rect width="24" height="24" rx="6" fill="#9FE870" />
    <path
      d="M6.5 16.5 10.2 7h2.4l2.2 6.1L17.1 7H19.5l-3.8 9.5h-2.3L11.2 10l-2.3 6.5H6.5z"
      fill="#163300"
    />
  </svg>
);

const RevolutIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
    <rect width="24" height="24" rx="6" fill="#191C1F" />
    <path
      d="M8 6.5h5.1c2.2 0 3.6 1.3 3.6 3.2 0 1.5-.8 2.6-2.1 3l2.5 4.8h-2.6l-2.3-4.5H10.3v4.5H8V6.5zm2.3 5.1h2.5c1.1 0 1.7-.5 1.7-1.4s-.6-1.4-1.7-1.4h-2.5v2.8z"
      fill="#fff"
    />
  </svg>
);

const PayPalIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
    <rect width="24" height="24" rx="6" fill="#003087" />
    <path
      d="M9.2 17.5 10 13.2h2.2c2.3 0 3.8-1.1 4.2-3 .3-1.5-.4-2.7-2.1-2.7H10.8L9.2 17.5H7.1l2.4-13h4.8c3.1 0 5.1 1.6 4.5 4.5-.7 3.4-3.3 5.1-6.6 5.1H10.4l-.7 3.9H7.6l1.6-8.6"
      fill="#009CDE"
    />
    <path d="M10.8 7.5h2.5c1.2 0 1.9.5 1.7 1.6-.3 1.3-1.3 2-2.6 2H11.3l.5-3.6z" fill="#fff" />
  </svg>
);

/**
 * Brand / theme icons for alternative payout method cards.
 */
const IconPayoutMethod = props => {
  const { method, className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  switch (method) {
    case ALTERNATIVE_PAYOUT_METHODS.WISE:
      return <WiseIcon className={classes} />;
    case ALTERNATIVE_PAYOUT_METHODS.REVOLUT:
      return <RevolutIcon className={classes} />;
    case ALTERNATIVE_PAYOUT_METHODS.PAYPAL:
      return <PayPalIcon className={classes} />;
    case ALTERNATIVE_PAYOUT_METHODS.BANK_TRANSFER:
      return <AccountBalanceOutlinedIcon className={classNames(classes, css.bankIcon)} />;
    default:
      return null;
  }
};

IconPayoutMethod.defaultProps = {
  className: null,
  rootClassName: null,
  method: null,
};

IconPayoutMethod.propTypes = {
  method: string,
  className: string,
  rootClassName: string,
};

export default IconPayoutMethod;
